import { useRef } from "react";
import { Nullable } from "../api/types";
import { FormHandle } from "../types";

export default function useFormRef<T>() {
    return useRef<FormHandle<Nullable<T>> | null>(null);
}
